<template>
  <div>
    <b-modal size="lg" hide-footer no-close-on-esc no-close-on-backdrop :visible="visible" @hidden="$emit('close')">
      <template #modal-header="{ close }">
        <h5 class="modal-title">{{ title }}</h5>
        <div class="d-flex">
          <b-button
            variant="success"
            size="sm"
            class="mr-2"
            @click="navigateToDashboard"
            v-b-tooltip.hover
            title="View in Bunker Dashboard"
          >
            <i class="ri-dashboard-line"></i> View Dashboard
          </b-button>
          <b-button size="sm" variant="transparent" @click="close()">
            <i class="ri-close-line"></i>
          </b-button>
        </div>
      </template>
      <div class="iq-card mb-0">
        <div v-if="isLoading" class="text-center p-5">
          <b-spinner label="Loading..."></b-spinner>
        </div>
        <div v-else-if="detailData" class="iq-card-body">
          <!-- Detail Header yang Diperbarui -->
          <div class="detail-header-card mb-4">
            <b-row>
              <b-col md="6" class="mb-3">
                <div class="d-flex align-items-center">
                  <i class="ri-ship-line h3 text-primary mr-3 mb-0"></i>
                  <div>
                    <p class="text-muted mb-0 small">Vessel</p>
                    <h6 class="font-weight-bold mb-0">{{ details.vessel }}</h6>
                  </div>
                </div>
              </b-col>
              <b-col md="6" class="mb-3">
                <div class="d-flex align-items-center">
                  <i class="ri-map-pin-line h3 text-primary mr-3 mb-0"></i>
                  <div>
                    <p class="text-muted mb-0 small">Location</p>
                    <h6 class="font-weight-bold mb-0">{{ details.location }}</h6>
                  </div>
                </div>
              </b-col>
              <b-col md="6" class="mb-3 mb-md-0">
                <div class="d-flex align-items-center">
                  <i class="ri-time-line h3 text-primary mr-3 mb-0"></i>
                  <div>
                    <p class="text-muted mb-0 small">Time</p>
                    <h6 class="font-weight-bold mb-0">{{ details.time }}</h6>
                  </div>
                </div>
              </b-col>
              <b-col md="6" class="mb-3 mb-md-0">
                <div class="d-flex align-items-center">
                  <i class="ri-gas-station-line h3 text-primary mr-3 mb-0"></i>
                  <div>
                    <p class="text-muted mb-0 small">Fuel Type</p>
                    <h6 class="font-weight-bold mb-0">{{ details.fuelType }}</h6>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>

          <b-tabs content-class="mt-3">
            <b-tab title="" active>
              <!-- Kartu Utama: Received vs Target -->
              <template #title>
                Bunker Summary <b-badge v-if="summary.flagReset == true" variant="warning">RESETED</b-badge>
              </template>
              <b-row class="mb-4">
                <b-col md="6">
                  <b-card no-body class="text-center shadow-sm border-success h-100">
                    <div class="card-header bg-success-light font-weight-bold text-success">
                      <i class="ri-gas-station-fill mr-2"></i>Final Bunker Received
                    </div>
                    <b-card-body>
                      <h1 class="display-4 font-weight-bold text-success mb-0">{{ summary.finalReceived }}</h1>
                      <p class="text-muted mb-0">KL</p>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col md="6">
                  <b-card no-body class="text-center shadow-sm border-primary h-100">
                    <div class="card-header bg-primary-light font-weight-bold text-primary">
                      <i class="ri-focus-3-line mr-2"></i>Target Bunker
                    </div>
                    <b-card-body>
                      <h1 class="display-4 font-weight-bold text-primary mb-0">{{ summary.target }}</h1>
                      <p class="text-muted mb-0">KL</p>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>

              <!-- Kartu Pendukung -->
              <b-row class="mb-3">
                <b-col md="4">
                  <b-card class="text-center summary-card h-100" body-class="d-flex flex-column h-100">
                    <p class="text-muted mb-2"><i class="ri-dashboard-3-line mr-2"></i>Total Bunker MANTRAZ</p>
                    <h3 class="font-weight-bold mt-auto">{{ summary.mantraz }} <small class="text-muted">KL</small></h3>
                  </b-card>
                </b-col>
                <b-col md="4">
                  <b-card class="text-center summary-card h-100" body-class="d-flex flex-column h-100">
                    <p class="text-muted mb-2"><i class="ri-tools-line mr-2"></i>Total Adjustment</p>
                    <h3 class="font-weight-bold mt-auto"
                      :class="summary.adjustmentNumeric >= 0 ? 'text-primary' : 'text-danger'">{{ summary.adjustment }}
                      <small class="text-muted">KL</small></h3>
                  </b-card>
                </b-col>
                <b-col md="4">
                  <b-card class="text-center summary-card h-100" body-class="d-flex flex-column h-100">
                    <p class="text-muted mb-2"><i class="ri-sound-module-line mr-2"></i>Total Bunker (Sounding)</p>
                    <h3 class="font-weight-bold mt-auto">{{ summary.sounding }} <small class="text-muted">KL</small>
                    </h3>
                  </b-card>
                </b-col>
              </b-row>

              <!-- Kartu Diskrepansi -->
              <b-row>
                <b-col md="6">
                  <b-card class="summary-card h-100">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <p class="mb-1 text-muted">Discrepancy (vs Target)</p>
                        <h5 class="font-weight-bold mb-0"
                          :class="summary.discrepancyTargetAmount >= 0 ? 'text-info' : 'text-danger'">
                          {{ summary.discrepancyVsTarget }}
                        </h5>
                      </div>
                      <i class="ri-arrow-left-right-line h1 text-light"></i>
                    </div>
                  </b-card>
                </b-col>
                <b-col md="6">
                  <b-card class="summary-card h-100">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <p class="mb-1 text-muted">Discrepancy (vs Sounding)</p>
                        <h5 class="font-weight-bold mb-0"
                          :class="summary.discrepancySoundingAmount >= 0 ? 'text-info' : 'text-danger'">
                          {{ summary.discrepancyVsSounding }}
                        </h5>
                      </div>
                      <i class="ri-ruler-2-line h1 text-light"></i>
                    </div>
                  </b-card>
                </b-col>
              </b-row>

              <!-- Report Notes -->
              <div class="mt-4">
                <div class="card shadow-sm">
                  <div class="iq-card-body">
                    <h6 class="iq-card-title font-weight-bold">Report Notes</h6>
                    <p class="iq-card-text text-muted mb-0 note-text">{{ notes.report }}</p>
                  </div>
                </div>
              </div>
              <div class="mt-3" v-if="canRead('master_bunker_adjustment') && notes.lastAdjustmentNote">
                <div class="iq-card shadow-sm">
                  <div class="iq-card-body">
                    <h6 class="iq-card-title font-weight-bold">Last Adjustment Note ({{ notes.lastAdjustmentDate }})
                    </h6>
                    <p class="iq-card-text text-muted mb-0 note-text">{{ notes.lastAdjustmentNote }}</p>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab v-if="canRead('master_bunker_adjustment')">
              <template #title>
                Adjustment History <b-badge v-if="adjustmentHistory.length" variant="warning">ADJUSTED</b-badge>
              </template>
              <div class="d-flex justify-content-end mb-3">
                <b-button v-if="canCreate('master_bunker_adjustment')" variant="primary" size="sm"
                  @click="openAddAdjustment">
                  <i class="ri-add-line mr-1"></i> Add Adjustment
                </b-button>
              </div>
              <!-- Desktop: tabel biasa -->
              <div class="table-responsive adj-desktop-table">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th style="min-width: 200px">Date</th>
                      <th style="min-width: 100px">Type</th>
                      <th style="min-width: 120px">Value (KL)</th>
                      <th>Reason</th>
                      <th style="min-width: 200px">Note (Click to view)</th>
                      <th>User</th>
                      <th v-if="canUpdate('master_bunker_adjustment') || canDelete('master_bunker_adjustment')"
                        style="min-width: 220px">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!adjustmentHistory.length">
                      <td colspan="6" class="text-center">No adjustment history.</td>
                    </tr>
                    <tr v-for="item in adjustmentHistory" :key="item.id">
                      <td>{{ item.date }}</td>
                      <td>{{ item.type === 1 ? 'Reset Value' : 'Adjust Value' }}</td>
                      <td :class="{ 'text-danger': item.value < 0 }">{{ item.value }}</td>
                      <td>{{ item.reason }}</td>
                      <td>
                        <a href="#" @click.prevent="showNoteDetail(item.fullNote)" v-if="item.fullNote"
                          class="note-link">
                          {{ item.note }}
                        </a>
                        <span v-else>-</span>
                      </td>
                      <td>{{ item.user }}</td>
                      <td v-if="canUpdate('master_bunker_adjustment') || canDelete('master_bunker_adjustment')">
                        <b-button-group size="sm">
                          <b-button v-if="canUpdate('master_bunker_adjustment')" variant="info"
                            @click="openEditAdjustment(item)" v-b-tooltip.hover title="Edit">
                            <i class="ri-pencil-line"></i> Edit
                          </b-button>
                          <b-button v-if="canDelete('master_bunker_adjustment')" variant="danger"
                            @click="openDeleteAdjustment(item)" v-b-tooltip.hover title="Delete">
                            <i class="ri-delete-bin-line"></i> Delete
                          </b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Mobile: card layout -->
              <div class="adj-mobile-cards">
                <div v-if="!adjustmentHistory.length" class="text-center py-3 text-muted">
                  No adjustment history.
                </div>
                <div v-else class="adj-card-list">
                  <div v-for="item in adjustmentHistory" :key="item.id" class="adj-card">
                    <div class="adj-card-header">
                      <span class="adj-card-date">{{ item.date }}</span>
                      <span class="badge" :class="item.type === 1 ? 'badge-warning' : 'badge-info'">
                        {{ item.type === 1 ? 'Reset Value' : 'Adjust Value' }}
                      </span>
                    </div>
                    <div class="adj-card-body">
                      <div class="adj-card-row">
                        <span class="adj-card-label">Value (KL)</span>
                        <span class="adj-card-value" :class="{ 'text-danger': item.value < 0 }">{{ item.value }}</span>
                      </div>
                      <div class="adj-card-row">
                        <span class="adj-card-label">Reason</span>
                        <span class="adj-card-value">{{ item.reason || '-' }}</span>
                      </div>
                      <div class="adj-card-row">
                        <span class="adj-card-label">Note</span>
                        <span class="adj-card-value">
                          <a href="#" @click.prevent="showNoteDetail(item.fullNote)" v-if="item.fullNote" class="note-link">
                            {{ item.note }}
                          </a>
                          <span v-else>-</span>
                        </span>
                      </div>
                      <div class="adj-card-row">
                        <span class="adj-card-label">User</span>
                        <span class="adj-card-value">{{ item.user || '-' }}</span>
                      </div>
                    </div>
                    <div class="adj-card-footer" v-if="canUpdate('master_bunker_adjustment') || canDelete('master_bunker_adjustment')">
                      <b-button v-if="canUpdate('master_bunker_adjustment')" variant="info" size="sm"
                        @click="openEditAdjustment(item)">
                        <i class="ri-pencil-line"></i> Edit
                      </b-button>
                      <b-button v-if="canDelete('master_bunker_adjustment')" variant="danger" size="sm"
                        @click="openDeleteAdjustment(item)">
                        <i class="ri-delete-bin-line"></i> Delete
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </b-modal>
    <adjustment-form :visible="showAdjustmentModal" :is-submitting="isSubmittingAdjustment"
      :initial-data="selectedAdjustment" @close="showAdjustmentModal = false" @submit="handleAdjustmentSubmit" />
    <b-modal v-model="showNoteDetailModal" title="Adjustment Note Detail" ok-only ok-title="Close">
      <p class="note-text">{{ selectedNote }}</p>
    </b-modal>

    <b-modal v-model="showDeleteAdjustmentModal" title="Confirm Deletion" centered hide-footer no-close-on-backdrop>
      <p>Are you sure you want to delete this adjustment history?</p>
      <div class="text-right">
        <b-button variant="secondary" @click="showDeleteAdjustmentModal = false" :disabled="isSubmittingDeletion"
          class="mr-2">
          Cancel
        </b-button>
        <b-button variant="danger" @click="handleConfirmDeletion" :disabled="isSubmittingDeletion">
          <b-spinner v-if="isSubmittingDeletion" small></b-spinner>
          Delete
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import {
  apiDatetimeToUnix, fromApiDatetime, DISPLAY_DATETIME, DISPLAY_DATE,
} from '@/util/apiDatetime';
import BunkeringLogSvc from '@/services/BunkeringLogSvc';
import { formatNum } from '@/util/number';
import AdjustmentForm from './AdjustmentForm.vue';

export default {
  name: 'BunkeringLogDetail',
  components: {
    AdjustmentForm,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      detailData: null,
      isLoading: false,
      showAdjustmentModal: false,
      isSubmittingAdjustment: false,
      showNoteDetailModal: false,
      selectedNote: '',
      showDeleteAdjustmentModal: false,
      isSubmittingDeletion: false,
      selectedAdjustment: null,
    };
  },
  computed: {
    title() {
      if (!this.data?.bklgMass) return 'Bunkering Log Detail';
      const vesselName = this.data.bklgMass.massName || 'N/A';
      const location = this.data.bklgMblo?.mbloName || 'N/A';
      const date = fromApiDatetime(this.data.bklgEndDatetime).format(DISPLAY_DATE);
      return `${vesselName} - ${location} - ${date}`;
    },
    details() {
      if (!this.data) return {};
      const startTime = fromApiDatetime(this.data.bklgStartDatetime).format(DISPLAY_DATETIME);
      const endTime = fromApiDatetime(this.data.bklgEndDatetime).format(DISPLAY_DATETIME);
      return {
        vessel: this.data.bklgMass?.massName || 'N/A',
        location: this.data.bklgMblo?.mbloName || 'N/A',
        time: `${startTime} - ${endTime}`,
        fuelType: this.data.bklgMfty?.mftyName || 'N/A',
      };
    },
    summary() {
      if (!this.detailData) return {};

      const toKL = (liters) => (parseFloat(liters || 0) / 1000);
      const formatNumber = (num) => {
        const number = parseFloat(num);
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(number)) return num;
        return formatNum(number, 2);
      };

      const discrepancyTarget = this.detailData.discrepancyToTarget || {};
      const discrepancySounding = this.detailData.discrepancyToSounding || {};

      const discrepancyVsTargetText = `${discrepancyTarget.amount > 0 ? '+' : ''}${formatNumber(toKL(discrepancyTarget.amount))} KL (${formatNum((discrepancyTarget.percentage || 0), 2)}%)`;
      const discrepancyVsSoundingText = `${discrepancySounding.amount > 0 ? '+' : ''}${formatNumber(toKL(discrepancySounding.amount))} KL (${formatNum((discrepancySounding.percentage || 0), 2)}%)`;

      const finalReceivedNumeric = toKL(this.detailData.finalBunker);
      const targetNumeric = toKL(this.detailData.targetBunker);

      return {
        // Formatted strings for display
        mantraz: formatNumber(toKL(this.detailData.totalBunkerFlowmeter)),
        adjustment: formatNumber(toKL(this.detailData.totalAdjustment)),
        finalReceived: formatNumber(finalReceivedNumeric),
        target: formatNumber(targetNumeric),
        sounding: formatNumber(toKL(this.detailData.totalBunkerSounding)),
        discrepancyVsTarget: discrepancyVsTargetText,
        discrepancyVsSounding: discrepancyVsSoundingText,
        flagReset: this.detailData.flagReset,

        // Raw numbers for logic (conditional classes)
        finalReceivedNumeric,
        targetNumeric,
        adjustmentNumeric: toKL(this.detailData.totalAdjustment),
        discrepancyTargetAmount: toKL(discrepancyTarget.amount),
        discrepancySoundingAmount: toKL(discrepancySounding.amount),
      };
    },
    notes() {
      if (!this.data) return {};
      const lastAdjustment = this.adjustmentHistory[0];
      return {
        report: this.data.bklgNote || 'No notes provided.',
        lastAdjustmentDate: lastAdjustment ? lastAdjustment.date : 'N/A',
        lastAdjustmentNote: lastAdjustment ? lastAdjustment.fullNote : null,
      };
    },
    adjustmentHistory() {
      if (!this.detailData?.adjustments) return [];
      const truncate = (text, length = 30) => {
        if (text && text.length > length) {
          return `${text.substring(0, length)}...`;
        }
        return text;
      };
      return Object.values(this.detailData.adjustments)
        .sort((a, b) => moment(b.bklaCreatedTime).diff(moment(a.bklaCreatedTime)))
        .map((adj) => ({
          id: adj.bklaId,
          date: fromApiDatetime(adj.bklaCreatedTime).format(DISPLAY_DATETIME),
          rawDate: adj.bklaCreatedTime,
          value: formatNum((parseFloat(adj.bklaAmount || 0) / 1000), 3),
          amount: adj.bklaAmount,
          reason: adj?.bklaReason?.replace(/_/g, ' '),
          reasonValue: adj.bklaReason,
          type: adj?.bklaType,
          fullNote: adj.bklaDesc,
          note: truncate(adj.bklaDesc),
          user: adj.bklaCreatedUserId,
        }));
    },
  },
  methods: {
    async fetchDetail(logId) {
      if (!logId) return;
      this.isLoading = true;
      try {
        const response = await BunkeringLogSvc.getBunkeringLogDetailById(logId);
        if (response.data) {
          this.detailData = response.data;
        } else {
          this.detailData = response;
        }
      } catch (error) {
        console.error('Failed to fetch bunkering log detail:', error);
        this.$toast.error('Failed to fetch detail data.');
        this.detailData = null;
      } finally {
        this.isLoading = false;
      }
    },
    navigateToDashboard() {
      if (!this.data?.bklgMassId) {
        this.$toast.error('Asset ID is not available');
        return;
      }

      const massId = this.data.bklgMassId;
      const startUnix = apiDatetimeToUnix(this.data.bklgStartDatetime);
      const endUnix = apiDatetimeToUnix(this.data.bklgEndDatetime);

      this.$router.push({
        path: '/dashboard/bunker',
        query: {
          massId,
          start: startUnix,
          end: endUnix,
          interval: 'minute',
        },
      });
    },
    async handleAdjustmentSubmit(formData) {
      this.isSubmittingAdjustment = true;
      try {
        const payload = {
          bklaBklgId: this.data.bklgId,
          bklaAmount: formData.amount,
          bklaReason: formData.reason,
          bklaType: formData.type,
          bklaDesc: formData.note,
        };
        if (formData.id) {
          await BunkeringLogSvc.updateBunkerAdjustment(formData.id, payload);
          this.$toast.success('Adjustment updated successfully!');
        } else {
          await BunkeringLogSvc.createBunkerAdjustment(payload);
          this.$toast.success('Adjustment created successfully!');
        }
        await this.fetchDetail(this.data.bklgId);
        this.showAdjustmentModal = false;
        this.selectedAdjustment = null;
      } catch (error) {
        console.error('Failed to submit adjustment:', error);
        this.$toast.error('Failed to submit adjustment.');
      } finally {
        this.isSubmittingAdjustment = false;
      }
    },
    async handleConfirmDeletion() {
      if (!this.selectedAdjustment) return;
      this.isSubmittingDeletion = true;
      try {
        await BunkeringLogSvc.deleteBunkerAdjustment(this.selectedAdjustment.id);
        this.$toast.success('Adjustment deleted successfully!');
        this.showDeleteAdjustmentModal = false;
        await this.fetchDetail(this.data.bklgId);
        this.selectedAdjustment = null;
      } catch (error) {
        console.error('Failed to delete adjustment:', error);
        this.$toast.error('Failed to delete adjustment.');
      } finally {
        this.isSubmittingDeletion = false;
      }
    },
    showNoteDetail(note) {
      this.selectedNote = note;
      this.showNoteDetailModal = true;
    },
    openAddAdjustment() {
      this.selectedAdjustment = null;
      this.showAdjustmentModal = true;
    },
    openEditAdjustment(adjustment) {
      this.selectedAdjustment = { ...adjustment };
      console.log('Selected Adjustment for Edit:', this.selectedAdjustment);
      this.showAdjustmentModal = true;
    },
    openDeleteAdjustment(adjustment) {
      this.selectedAdjustment = adjustment;
      this.showDeleteAdjustmentModal = true;
    },
  },
  watch: {
    visible(newVal) {
      if (newVal && this.data && this.data.bklgId) {
        this.fetchDetail(this.data.bklgId);
      } else {
        this.detailData = null;
      }
    },
  },
};
</script>

<style scoped>
.bg-warning-light {
  background-color: #fffbe6;
}

.bg-success-light {
  background-color: #f0fff4;
}

.bg-primary-light {
  background-color: #e7f3ff;
}

.note-text {
  word-wrap: break-word;
  word-break: break-word;
}

.note-link {
  cursor: pointer;
  text-decoration: underline;
  color: #007bff;
}

.note-link:hover {
  color: #0056b3;
}

.summary-card {
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
  margin-bottom: 1rem;
}

.summary-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.card-header.bg-success-light,
.card-header.bg-primary-light {
  border-bottom: none;
}

/* CSS Tambahan untuk Detail Header */
.detail-header-card {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 1.25rem;
}

/* Adjustment history: show/hide per breakpoint */
.adj-desktop-table { display: block; }
.adj-mobile-cards  { display: none; }

@media (max-width: 767px) {
  .adj-desktop-table { display: none; }
  .adj-mobile-cards  { display: block; }
}

/* Adjustment card layout */
.adj-card-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0 12px;
}

.adj-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.adj-card-header {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 8px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.adj-card-date {
  font-size: 13px;
  font-weight: 600;
  color: #343a40;
}

.adj-card-body {
  padding: 10px 14px;
}

.adj-card-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 5px 0;
  border-bottom: 1px solid #f0f0f0;
  gap: 8px;
}

.adj-card-row:last-child {
  border-bottom: none;
}

.adj-card-label {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
  flex-shrink: 0;
  min-width: 90px;
}

.adj-card-value {
  font-size: 13px;
  color: #212529;
  text-align: right;
}

.adj-card-footer {
  padding: 8px 14px;
  background: #f8f9fa;
  border-top: 1px solid #dee2e6;
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}
</style>
